export default "__VITE_ASSET__CuljV1GO__"